import { DateTime } from 'luxon';

import { DEFAULT_TIMEZONE } from 'shared/constants';

export const formatDate = (date: string) =>
  DateTime.fromISO(date, { zone: DEFAULT_TIMEZONE }).toLocal().toFormat('dd/MM/yyyy');
